import React from "react"
import { Link } from "gatsby"

import * as style from "./mainnav.module.scss"

const MainNav = ({ menuLinks }) => {
  return (
    <nav className={style.nav}>
      <ul>
        {menuLinks.map(props => (
          <li key={props.name}>
            <Link to={props.link}>{props.name}</Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default MainNav
